import type { ReactNode } from "react";
import { Box, Stack, Text } from "@mantine/core";

/** A titled block of a document-type form (General, Mapping, SharePoint). */
export const FormSection = ({ title, description, children }: { title: string; description?: string; children: ReactNode }) => (
    <Box component="section" className="doctype-form-section">
        <Text fw={600}>{title}</Text>
        {description && <Text size="xs" c="dimmed">{description}</Text>}
        <Stack gap="md" mt="sm">{children}</Stack>
    </Box>
);
